import Layout from './Layout';
import ForeignExchangesFakeDoorPage from './FakeDoorPage.vue';

export default {
  path: '/internacional',
  component: Layout,
  name: 'Foreign',
  redirect: {
    name: 'ForeignExchanges'
  },
  children: [
    {
      path: 'remessas',
      name: 'ForeignExchanges',
      redirect: {
        name: 'ForeignExchangesFakeDoorPage'
      },
      children: [
        {
          name: 'ForeignExchangesFakeDoorPage',
          path: 'acesso',
          component: ForeignExchangesFakeDoorPage,
          props: { firstAccess: true }
        },
        {
          name: 'ForeignExchangesKnowMorePage',
          path: 'saiba-mais',
          component: ForeignExchangesFakeDoorPage
        }
      ]
    }
  ]
};
